/* Build My First Hijab Plan - vanilla, no dependencies, no storage.
   Reads the selected radio values, combines rules that also exist as static
   HTML on the page, and renders a practical plan. It never decides a religious
   question and never records the selected answers. Analytics events are
   anonymous (started / completed) with no answer payload. */
(function () {
  'use strict';

  var form = document.getElementById('fhg-plan-form');
  if (!form) return;

  var result = document.getElementById('fhg-plan-result');
  var heading = document.getElementById('fhg-plan-result-heading');
  var validation = document.getElementById('fhg-plan-validation');
  var started = false;

  function emit(name) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: name });
      }
      document.dispatchEvent(new CustomEvent(name));
    } catch (e) { /* analytics is non-essential */ }
  }

  function val(name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }

  form.addEventListener('change', function () {
    if (!started) { started = true; emit('first_hijab_plan_started'); }
  });

  function buildType(a) {
    var s;
    if (a.activity === 'active' || a.worry === 'pe') {
      s = 'A close, secure sports or pull-on style with no sharp pins or loose ends. Check the specific sport and your school rules.';
    } else if (a.fabric === 'soft') {
      s = 'A soft jersey or a soft pull-on jersey style, subject to fit.';
    } else if (a.fabric === 'flowy' && a.activity === 'sitting') {
      s = 'Compare a chiffon or a two-layer instant style, with an honest note that slippery fabrics may need a securing layer or fastener.';
    } else if (a.fabric === 'fewlayers') {
      s = 'A one-piece construction. Avoid adding an undercap unless it is needed for fit or coverage.';
    } else if (a.pullon === 'yes') {
      s = 'A one-piece pull-on so you can put it on and adjust it quickly.';
    } else {
      s = 'A well fitting one-piece or pull-on jersey style is a practical starting point.';
    }
    if (a.worry === 'slipping') {
      s += ' Prioritise a correct face opening, a grippier fabric and a pull-on option to reduce adjustments.';
    }
    if (a.colour && a.colour !== 'none') {
      s += ' Look for it in ' + a.colour + '.';
    }
    return s;
  }

  function buildPractise(a) {
    var s = 'Wear your chosen hijab at home for 20 to 30 minutes. Put on your glasses, coat and backpack, then speak, look down to read, turn your head and try a short burst of movement.';
    if (a.worry === 'glasses') {
      s += ' Do the wear test with your glasses in their normal position and reject any opening or undercap that presses the arms into your ears.';
    }
    if (a.activity === 'active' || a.worry === 'pe') {
      s += ' Test the PE option separately with more movement and check nothing comes loose.';
    }
    if (a.worry === 'pressure') {
      s += ' If anything presses or aches, loosen or change the style and tell an adult. Pain is not something to get used to.';
    }
    return s;
  }

  function buildPack(a) {
    var s = 'A spare hijab where practical, a small clean pouch, only fasteners your school allows, a water bottle and the first day checklist.';
    if (a.activity === 'active' || a.worry === 'pe') {
      s += ' Keep a separate clean sports hijab if you can.';
    }
    if (a.independent === 'adult' || a.independent === 'learning') {
      s += ' Leave time for an adult to help until the routine feels easy.';
    }
    return s;
  }

  function buildAsk(a) {
    var s = "Your school's permitted hijab colour and style, the PE safety rules, who can help if it slips, and where you can adjust it privately if needed.";
    if (a.worry === 'questions') {
      s += ' Also ask how the school handles unwanted comments, and agree who your trusted adult will be.';
    }
    return s;
  }

  function nextLink(a) {
    var map = {
      slipping: ['#comfort-troubleshooting', 'the comfort troubleshooter'],
      hot: ['#comfort-troubleshooting', 'the comfort troubleshooter'],
      pressure: ['#comfort-troubleshooting', 'the comfort troubleshooter'],
      glasses: ['#comfort-troubleshooting', 'the comfort troubleshooter'],
      neck: ['#comfort-troubleshooting', 'the comfort troubleshooter'],
      questions: ['#friends-and-questions', 'friends, questions and unwanted comments'],
      pe: ['#pe-and-sport', 'PE, sport and physical activity']
    };
    var m = a.worry && map[a.worry] ? map[a.worry] : ['#hijab-types', 'the hijab type comparison'];
    return m;
  }

  function setText(id, text) { document.getElementById(id).textContent = text; }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var a = {
      place: val('place'), activity: val('activity'), fabric: val('fabric'),
      pullon: val('pullon'), colour: val('colour'), worry: val('worry'),
      independent: val('independent')
    };

    var any = Object.keys(a).some(function (k) { return a[k]; });
    if (!any) {
      validation.textContent = 'Choose at least one option above to build your plan.';
      validation.hidden = false;
      validation.focus && validation.setAttribute('tabindex', '-1');
      return;
    }
    validation.hidden = true;

    setText('fhg-result-type', buildType(a));
    setText('fhg-result-practise', buildPractise(a));
    setText('fhg-result-pack', buildPack(a));
    setText('fhg-result-ask', buildAsk(a));

    var nx = nextLink(a);
    var next = document.getElementById('fhg-result-next');
    next.innerHTML = '';
    next.appendChild(document.createTextNode('Read next: '));
    var link = document.createElement('a');
    link.href = nx[0];
    link.textContent = nx[1];
    next.appendChild(link);
    next.appendChild(document.createTextNode('.'));

    result.hidden = false;
    if (heading && typeof heading.focus === 'function') { heading.focus(); }
    emit('first_hijab_plan_completed');
  });

  var resetBtn = document.getElementById('fhg-plan-reset');
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      result.hidden = true;
      validation.hidden = true;
      started = false;
    });
  }

  var printBtn = document.getElementById('fhg-plan-print');
  if (printBtn) {
    printBtn.addEventListener('click', function () { window.print(); });
  }
})();
